<template>
  <div v-if="customerStore.customerList && projectStore.projectList" class="">
    <div id="target-project" class="d-flex align-items-stretch flex-wrap flex-sm-nowrap h-100">
      <div
        v-click-outside="closeCustomerDropdown"
        class="navbar__select"
        tabindex="1"
        @click="toggleCustomersList()"
        @keyup.prevent.up="prevCustomer($event)"
        @keyup.prevent.down="nextCustomer($event)"
        @keyup.enter="
          () => {
            setCustomer(preselectedCustomer)
            autoSetProject = true
          }
        "
      >
        <div :class="{ active: customersOpened }" class="navbar__select__item navbar__item" style="position: relative">
          <span class="clearfix" style="position: relative; display: inline-block">
            <input
              ref="search"
              v-model="customerSearch"
              style="background: transparent; border: none !important; outline: none; color: #fff"
              tabindex="1"
              type="text"
              @keydown="searchInCustomers()"
              @keyup="searchInCustomers()"
              @keyup.enter="
                () => {
                  setCustomer(preselectedCustomer)
                  autoSetProject = true
                }
              "
            />

            <span
              v-if="customerStore.selectedCustomer && customerSearch.length === 0"
              style="
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
              "
            >
              {{ customerStore.selectedCustomer.customerName }}
            </span>
          </span>
          <img class="navbar__select__arrow" src="@/assets/icons/arrows/arr-orange-down.svg" />
        </div>
        <div v-if="customersOpened" class="navbar__select__options">
          <div v-if="cust.length > 0" ref="scrollContainer" class="navbar__select__inner">
            <div v-for="customer1 in cust" :key="customer1.customerId" ref="options">
              <div
                :class="{
                  preselected: preselectedCustomer.customerId === customer1.customerId
                }"
                class="navbar__select__option navbar__select__option--search"
                @click="
                  () => {
                    setCustomer(customer1)
                    autoSetProject = true
                  }
                "
              >
                <div class="check">
                  <img
                    v-if="customer1.customerId === customerStore.selectedCustomer.customerId"
                    class=""
                    src="@/assets/icons/check.svg"
                  />
                </div>
                {{ customer1.customerName }}
              </div>
            </div>
          </div>
          <div v-else ref="scrollContainer" class="navbar__select__inner">
            <div class="navbar__select__option navbar__select__option--search" style="border-bottom: none">
              <div class="check" />
              Žádné výsledky vyhledávání
            </div>
          </div>
        </div>
      </div>

      <div
        v-click-outside="closeProjectDropdown"
        class="navbar__select"
        tabindex="1"
        @click="toggleProjectsList()"
        @keyup.prevent.up="prevProject($event)"
        @keyup.prevent.down="nextProject($event)"
        @keyup.enter="setProject(preselectedProject)"
      >
        <div :class="{ active: projectsOpened }" class="navbar__select__item navbar__item">
          <span class="clearfix" style="position: relative; display: inline-block">
            <input
              ref="searchProject"
              v-model="projectSearch"
              :style="{
                visibility: this.projectsOpened ? 'visible' : 'hidden'
              }"
              style="background: transparent; border: none !important; outline: none; color: #fff"
              tabindex="1"
              type="text"
              @keydown="searchInProjects()"
              @keyup="searchInProjects()"
              @keyup.enter="setProject(preselectedProject)"
            />

            <span
              v-if="
                projectStore.selectedProject?.projectId &&
                projectStore.selectedProject.projectId !== 'undefined' &&
                projectSearch.length === 0
              "
              style="position: absolute; top: 0; left: 0"
            >
              {{ projectStore.selectedProject.projectName }}
            </span>
            <span
              v-if="!projectStore.selectedProject?.projectId || projectStore.selectedProject.projectId === 'undefined'"
              style="position: absolute; top: 0; left: 0"
            >
              {{ $t("zadnyProjekt") }}...
            </span>
          </span>

          <img class="navbar__select__arrow" src="@/assets/icons/arrows/arr-orange-down.svg" />
        </div>
        <div v-if="projectsOpened && filteredProjectList.length" class="navbar__select__options">
          <div ref="scrollContainer1" class="navbar__select__inner">
            <div
              v-for="project1 in filteredProjectList"
              :key="project1.projectId"
              ref="options1"
              :class="{
                preselected: preselectedProject.projectId === project1.projectId
              }"
              class="navbar__select__option navbar__select__option--search"
              @click="setProject(project1)"
            >
              <div class="check">
                <img
                  v-if="project1.projectId === projectStore.selectedProject?.projectId"
                  class=""
                  src="@/assets/icons/check.svg"
                />
              </div>
              {{ project1.projectName }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useAuthStore } from "@/store/modules/auth"
import { useCustomerStore } from "@/store/modules/customer"
import { useProjectStore } from "@/store/modules/project"
import { useConfigStore } from "@/store/modules/config"

export default {
  components: {},
  setup() {
    const authStore = useAuthStore()
    const customerStore = useCustomerStore()
    const projectStore = useProjectStore()
    const configStore = useConfigStore()

    return {
      authStore,
      customerStore,
      projectStore,
      configStore
    }
  },
  data() {
    return {
      filteredProjectList: [],
      customersSelect: [],
      projectSelect: [],
      selectedProjectModel: { label: "", code: "" },
      projectsVisible: false,
      loadedCustomer: {},
      loadedProjects: {},
      customersOpened: false,
      projectsOpened: false,
      autoSetProject: false,
      customerSearch: "",
      projectSearch: "",
      preselectedCustomer: {},
      preselectedProject: {},
      cust: [],
      openedSelect: "",
      vcoConfig: {
        handler: this.hideUserMenu,
        middleware: this.middleware,
        events: ["dblclick", "click"],
        isActive: true,
        detectIFrame: true,
        capture: false
      },
      vcoConfig1: {
        handler: this.hideUserMenu,
        middleware: this.middleware,
        events: ["dblclick", "click"],
        isActive: true,
        detectIFrame: true,
        capture: false
      }
    }
  },
  computed: {
    customersProjects() {
      return this.projectStore.projectList.filter(
        (p) => p.customerId === this.customerStore.selectedCustomer.customerId
      )
    }
  },
  watch: {
    "customerStore.customerList": function () {
      this.cust = this.customerList

      var data = []
      this.customerStore.customerList.forEach((customer) => {
        data.push({
          label: customer.customerName,
          code: customer.customerId,
          selected: true
        })
      })

      this.customersSelect = data
    },
    selectedProject() {
      if (this.project != null) {
        this.$store.dispatch("services/getServices")
      }
    },
    "customerStore.selectedCustomer": async function () {
      await this.projectStore.getProjectList()
      if (this.customersProjects.length > 0) {
        if (this.autoSetProject) {
          this.projectStore.setProject(this.customersProjects[0])
          this.autoSetProject = false
        }
        this.configStore.setNoProjectVisible({
          noProjectVisible: false,
          noProjectVisiblePageInfo: false
        })
      } else {
        this.projectStore.setProject(null)
        this.configStore.setNoProjectVisible({
          noProjectVisible: true,
          noProjectVisiblePageInfo: true
        })
      }
    },
    "projectStore.selectedProject": function () {
      this.authStore.getApiUser()
    },
    customersOpened() {
      if (this.customersOpened === true) {
        this.cust = this.customerStore.customerList
        this.preselectedCustomer = this.cust[0]
      }
    }
  },
  mounted() {},
  created() {
    if (this.customerStore.customerList.length > 0) {
      const data = []

      this.customerStore.customerList.forEach((customer) => {
        data.push({
          label: customer.customerName,
          code: customer.customerId,
          selected: true
        })
      })

      this.customersSelect = data
    }

    if (this.projectStore.projectList && this.projectStore.projectList.length > 0) {
      var data_project = []

      this.projectStore.projectList.forEach((project) => {
        data_project.push({
          label: project.projectName,
          code: project.projectId
        })
      })

      this.projectSelect = data_project
    }
  },
  methods: {
    nextCustomer() {
      let index = this.cust.indexOf(this.preselectedCustomer)
      if (index < this.cust.length - 1) {
        this.preselectedCustomer = this.cust[index + 1]
        this.fixScrolling()
      }
    },
    prevCustomer() {
      let index = this.cust.indexOf(this.preselectedCustomer)
      if (index >= 1) {
        this.preselectedCustomer = this.cust[index - 1]
        this.fixScrolling()
      }
    },
    nextProject() {
      let index = this.customersProjects.indexOf(this.preselectedProject)
      if (index < this.customersProjects.length - 1) {
        this.preselectedProject = this.customersProjects[index + 1]
        this.fixScrolling()
      }
    },
    prevProject() {
      let index = this.customersProjects.indexOf(this.preselectedProject)
      if (index >= 1) {
        this.preselectedProject = this.customersProjects[index - 1]
        this.fixScrolling()
      }
    },
    fixScrolling() {
      document.documentElement.scrollTop = 0
      let index, optH
      if (this.openedSelect === "customers") {
        index = this.cust.indexOf(this.preselectedCustomer)
        optH = this.$refs.options[index].clientHeight
        this.$refs.scrollContainer.scrollTop = optH * index
      } else if (this.openedSelect === "projects") {
        index = this.customersProjects.indexOf(this.preselectedProject)
        optH = this.$refs.options1[index].clientHeight
        this.$refs.scrollContainer1.scrollTop = optH * index
      }
    },
    setCustomer(customer) {
      // Goes through the store action so localStorage stays in sync — getApiUser() falls
      // back to it, and a stale entry derives privileges against the previous customer.
      this.customerStore.setCustomer(customer)
    },
    setProject(project) {
      // Enter on an empty dropdown hands over the {} default of preselectedProject.
      if (!project?.projectId) {
        return
      }
      this.projectStore.setProject(project)
    },
    closeCustomerDropdown() {
      this.customersOpened = false
    },
    closeProjectDropdown() {
      this.projectsOpened = false
    },
    searchInCustomers() {
      this.cust = this.customerStore.customerList.filter((item) => {
        return item.customerName.toLowerCase().indexOf(this.customerSearch.toLowerCase()) > -1
      })
    },
    searchInProjects() {
      this.filteredProjectList = this.customersProjects.filter((item) => {
        return item.projectName.toLowerCase().indexOf(this.projectSearch.toLowerCase()) > -1
      })
    },
    toggleCustomersList() {
      this.customersOpened = !this.customersOpened
      this.projectsOpened = false
      this.openedSelect = this.customersOpened ? "customers" : ""
      this.customerSearch = ""
      this.$nextTick(() => this.$refs.search?.focus())
    },
    toggleProjectsList() {
      this.filteredProjectList = this.customersProjects
      // A customer without projects has nothing to pick: keep the selector closed instead
      // of opening an empty panel over a hidden search input.
      if (!this.customersProjects.length) {
        this.projectsOpened = false
        this.customersOpened = false
        this.openedSelect = ""
        return
      }
      this.projectsOpened = !this.projectsOpened
      this.customersOpened = false
      this.openedSelect = this.projectsOpened ? "projects" : ""
      this.$nextTick(() => this.$refs.searchProject?.focus())
    }
  }
}
</script>
<style lang="scss" scoped></style>
